import { useSelector } from 'react-redux';
import BotBuilder from '../Bots/BotBuilder';
import WCABotBuilder from '../WCABots/BotBuilder/index';

const NewBotFlow = () => {
  const { companyConfigData } = useSelector((state) => state.authenticate);

  return companyConfigData?.wabaPartner === 'skalebot' ? <WCABotBuilder /> : <BotBuilder />;
};

export default NewBotFlow;
